export default function getViewportWidth() {
  var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
  var documentWidth;
  try {
    documentWidth = document.documentElement.clientWidth || 0;
  } catch (e) {
    documentWidth = 0;
  }
  return Math.max(documentWidth, window.innerWidth || 0);
}